module.exports = __webpack_public_path__ + "img/factory-m.775f5941.png";